import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const DeviceFieldCnt = styled('div')(() => ({
  width: '100%',
  padding: 14,
  backgroundColor: '#EEE',
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
  margin: '8px 0',
  '& .MuiChip-label': {
    paddingRight: 4
  }
}));

export const DevicesChipsCtn = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 4,
  '& div': {
    backgroundColor: '#FFF',
    border: 0
  }
}));

export const ButtonsContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: 16
}));

export const StyledAddBtn = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'initial',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: 8,
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16),' +
    '0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
  transition: 'none',
  width: '100%',
  padding: 12,
  backgroundColor: '#FFF',
  '&:hover': {
    backgroundColor: '#FFF'
  },
  '& span': {
    fontSize: theme.spacing(2)
  }
}));

export const StyledModifyBtn = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'initial',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: 8,
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16),' +
    '0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
  transition: 'none',
  width: '100%',
  padding: 12,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  '&:hover': {
    backgroundColor: theme.palette.secondary.main
  },
  '& span': {
    fontSize: theme.spacing(2)
  }
}));

export const TitleDiv = styled('div', {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ disabled }) => ({
  paddingBottom: 6,
  fontWeight: 500,
  color: disabled ? '#00000042' : 'inherit'
}));
